// ChangeInformationModal.jsx
import React, { useState } from "react";
import "./change-information.css";
import { IoClose } from "react-icons/io5";
import { ClipLoader } from "react-spinners";
import { updateInformation } from "../../api/user.api";
import { showTopCenterToast } from "../toasts/ToastNotification";

const FloatingInput = ({ label, value, onChange, disabled = false }) => {
    const hasValue = value && value.trim() !== "";

    return (
        <div className={`modal-details-input-container ${hasValue ? 'has-value' : ''}`}>
            <label className="modal-details-input-title">{label}</label>
            <input
                className="modal-details-input"
                placeholder=" "
                value={value}
                onChange={onChange}
                disabled={disabled}
            />
        </div>
    );
};

const ChangeInformationModal = ({ isOpen, onClose, user, setUser }) => {
    const [loading, setLoading] = useState(false);
    const [username, setUsername] = useState("");
    const [fullName, setFullName] = useState("");
    const [phone, setPhone] = useState("");
    const [error, setError] = useState(null);

    if (!isOpen) return null;

    const handleUpdateInformation = async () => {
        setError(null);
        try {
            setLoading(true);
            const res = await updateInformation(username, fullName, phone);
            if (res.success) {
                showTopCenterToast("Cập nhật thông tin thành công", "success");
                setUser(res.data.updatedUser);
                onClose();
            }
        } catch (error) {
            setError({ message: error.message });
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="feedback-modal-overlay">
            <div className="change-information-modal">
                <div className="modal-header">
                    <h2 className="change-information-header-title">Thay đổi thông tin</h2>
                    <button className="change-information-modal-close-btn" onClick={onClose}>
                        <IoClose />
                    </button>
                </div>
                <div className="modal-information-container">
                    <FloatingInput label="Họ và tên" value={fullName} onChange={(e) => setFullName(e.target.value)} />
                    <FloatingInput label="Tên đăng nhập" value={username} onChange={(e) => setUsername(e.target.value)} />
                    <FloatingInput label="Email" value={user?.email || ''} disabled />
                    <FloatingInput label="Số điện thoại" value={phone} onChange={(e) => setPhone(e.target.value)} />
                </div>
                {error && <p className="error-text">*{error?.message}</p>}
                <button
                    onClick={handleUpdateInformation}
                    disabled={loading}
                    className={`update-information-button ${loading && "disabled-button"}`}
                >
                    {loading ? <ClipLoader size={20} color="#fff" /> : "Sửa"}
                </button>
            </div>
        </div>
    );
};

export default ChangeInformationModal;
